import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosServices from '../../utils/axios';

const initialState = {
    suppliers: [],
    suppliersList: [],
    checkmateSuppliers: [],
    checkmateSuppliersLoading: false,
    checkmateSuppliersError: null,
    loading: false,
    actionLoading: false,
    error: null,
    supplierInfo: null,
    supplierInfoLoading: false,
    supplierInfoError: null,
    balance: {
        loading: false,
        error: null,
        data: null
    },
    supplierDetail: {
        loading: false,
        error: null,
        info: null,
        data: null
    },
    approvalList: {
        loading: false,
        error: null,
        data: []
    },
    approve: {
        loading: false,
        error: null,
        success: false
    },
    kmList: {
        loading: false,
        error: null,
        data: []
    },
    kmAction: {
        loading: false,
        error: null,
        success: false
    },
    supplierServices: {
        data: [],
        loading: false,
        error: null
    },
    withdrawPayment: {
        loading: false,
        error: null,
        data: null
    },
    withoutPictureServices: {
        loading: false,
        error: null,
        data: []
    }
};

// export const fetchSuppliers = createAsyncThunk(

export const fetchSuppliers = createAsyncThunk(
    'supplier/fetchSuppliers',
    async (params = null, { rejectWithValue }) => {
        try {
            // Her zaman tüm parametreleri gönder, değer yoksa boş string kullan
            const defaultParams = {
                idCity: "",
                idDistrict: "",
                mtKm: 0
            };

            const queryParams = {
                ...defaultParams,
                ...(params || {})
            };

            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-suppliers-with-km`,
                { params: queryParams }
            );
            
            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Tedarikçiler alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Tedarikçiler yüklenirken bir hata oluştu');
        }
    }
);

export const fetchSuppliersCheckmate = createAsyncThunk(
    'supplier/fetchSuppliersCheckmate',
    async (params = null, { rejectWithValue }) => {
        try {
            // Her zaman tüm parametreleri gönder, değer yoksa boş string kullan
            const defaultParams = {
                idCity: "",
                idDistrict: "",
                mtKm: 0 
            };

            const queryParams = {
                ...defaultParams,
                ...(params || {})
            };

            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-suppliers-with-km`,
                { params: queryParams }
            );
            
            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Tedarikçiler alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Tedarikçiler yüklenirken bir hata oluştu');
        }
    }
);

export const fetchSuppliersList = createAsyncThunk(
    'supplier/fetchSuppliersList',
    async (params = null, { rejectWithValue }) => {
        try {
            // Her zaman tüm parametreleri gönder, değer yoksa boş string kullan
            const defaultParams = {
                idCity: "",
                idDistrict: "",
                dsKeyword: ""
            };

            const queryParams = {
                ...defaultParams,
                ...(params || {})
            };

            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-suppliers`,
                { params: queryParams }
            );
            
            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Tedarikçiler alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Tedarikçiler yüklenirken bir hata oluştu');
        }
    }
);

export const addSupplier = createAsyncThunk(
    'supplier/addSupplier',
    async (supplierData, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/new-supplier`,
                supplierData
            );
            
            if (response.data?.statu === 200) {
                return response.data.data;
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Tedarikçi eklenemedi');
        } catch (error) {
            return rejectWithValue(error.message || 'Tedarikçi eklenirken bir hata oluştu');
        }
    }
);

export const updateSupplier = createAsyncThunk(
    'supplier/updateSupplier',
    async (supplierData, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/edit-supplier`,
                supplierData
            );
            
            if (response.data?.statu === 200) {
                return response.data.data;
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Tedarikçi güncellenemedi');
        } catch (error) {
            return rejectWithValue(error.exceptions?.[0]?.Message || 'Tedarikçi güncellenirken bir hata oluştu');
        }
    }
);

export const getSupplierInfo = createAsyncThunk(
    'supplier/getSupplierInfo',
    async ({ idCcnNotificationService, dsContractNo }, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-supplier-info?idCcnNotificationService=${idCcnNotificationService}&dsContractNo=${dsContractNo}`,
            );
            
            if (response.data?.statu === 200) {
                return response.data.data[0];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Tedarikçi bilgileri alınamadı');
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getSupplier = createAsyncThunk(
    'supplier/getSupplier',
    async (idSupplier, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-supplier`,
                { params: { idSupplier } }
            );
            
            if (response.data?.statu === 200) {
                return response.data.data;
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Tedarikçi bilgileri alınamadı');
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchSupplierServices = createAsyncThunk(
    'supplier/fetchSupplierServices',
    async ({ idSupplier, rowCount, dsLocationInfo }, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-service`,
                { params: { idSupplier, rowCount, dsLocationInfo } }
            );

            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            return rejectWithValue(response.data?.exceptions?.[0] || 'Hizmet listesi alınamadı');
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getSupplierBalance = createAsyncThunk(
    'supplier/getSupplierBalance',
    async (idSupplier, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/SupAccount/get-balance`,
                { params: { idSupplier } }
            );
            
            if (response.data?.statu === 200) {
                return response.data.data[0];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Bakiye bilgisi alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Bakiye bilgisi yüklenirken bir hata oluştu');
        }
    }
);

export const getInitialSupplierInfo = createAsyncThunk(
    'supplier/getInitialSupplierInfo',
    async ({ idCcnNotificationService, dsContractNo }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-supplier-info`,
                null,
                { 
                    params: { 
                        idCcnNotificationService, 
                        dsContractNo 
                    } 
                }
            );
            console.log(response.data);
            
            if (response.data?.statu === 200 && response.data.data?.[0]) {
                const supplierInfo = response.data.data[0];
                
                // idSupplier ile detay bilgileri al
                if (supplierInfo.idSupplier) {
                    dispatch(getSupplierDetail(supplierInfo.idSupplier));
                }  
                return supplierInfo;
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Tedarikçi bilgisi alınamadı');
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getSupplierDetail = createAsyncThunk(
    'supplier/getSupplierDetail',
    async (idSupplier, { rejectWithValue }) => {
        try { 
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-supplier`,
                { params: { idSupplier } }
            );
        if (response.data?.statu === 200) {
                return response.data.data; 
            }  
            return rejectWithValue(response.data?.exceptions?.[0] || 'Tedarikçi detayı alınamadı');
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getApprovalList = createAsyncThunk(
    'supplier/getApprovalList',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/SupAccount/get-to-be-approved`
            );
            
            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Onay listesi alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Onay listesi yüklenirken bir hata oluştu');
        }
    }
);

export const setApprove = createAsyncThunk(
    'supplier/setApprove',
    async (idNotificationServices, { rejectWithValue }) => {
        try {
            // Array formatını kontrol et
            const ids = Array.isArray(idNotificationServices) 
                ? idNotificationServices 
                : [idNotificationServices];

            // POST isteği olarak gönder
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/SupAccount/set-approve`,
                `[${ids.join(',')}]`,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data?.statu === 200) {
                return response.data;
            }
            return rejectWithValue(response.data?.exceptions?.[0] || 'Onay işlemi başarısız');
        } catch (error) {
            console.error('SetApprove Error:', error.response || error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getKmList = createAsyncThunk(
    'supplier/getKmList',
    async (idSupplier, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-km-supplier`,
                { params: { idSupplier } }
            );
            
            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'KM listesi alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'KM listesi yüklenirken bir hata oluştu');
        }
    }
);

export const addKm = createAsyncThunk(
    'supplier/addKm',
    async (kmData, { rejectWithValue, dispatch }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/new-km-supplier`,
                kmData
            );
            
            if (response.data?.statu === 200) {
                dispatch(getKmList(kmData.idSupplier));
                return response.data.data;
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'KM eklenemedi');
        } catch (error) {
            return rejectWithValue(error.message || 'KM eklenirken bir hata oluştu');
        }
    }
);

export const updateKm = createAsyncThunk(
    'supplier/updateKm',
    async (kmData, { rejectWithValue, dispatch }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/edit-km-supplier`,
                kmData
            );
            
            if (response.data?.statu === 200) {
                dispatch(getKmList(kmData.idSupplier));
                return response.data.data;
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'KM güncellenemedi');
        } catch (error) {
            return rejectWithValue(error.message || 'KM güncellenirken bir hata oluştu');
        }
    }
);

// tedarikçi ödeme talebi gönder
export const setWithdrawPayment = createAsyncThunk(
    'supplierApp/setWithDrawPayment',
    async (paymentData, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/SupAccount/set-withdraw-payment`,
                paymentData
            );

            // Response statusuna bakınız - hata varsa rejectWithValue kullanın
            if (response.data?.statu !== 200) {
                // Status 500 ve exceptions varsa mesajı çıkart
                if (response.data?.statu === 500 && response.data?.exceptions && response.data.exceptions.length > 0) {
                    return rejectWithValue(response.data.exceptions[0].Message || 'İşlem sırasında bir hata oluştu');
                }
                
                // Validasyon hatalarını kontrol et
                if (response.data?.statu === 800) {
                    return rejectWithValue({
                        statu: 800,
                        exceptions: response.data.exceptions
                    });
                }

                // Diğer durumlar
                return rejectWithValue(response.data?.exceptions?.[0]?.Message || response.data);
            }

            return response.data;
        } catch (error) { 
            // Axios hata yanıtını kontrol et
            if (error.response?.data?.statu === 500 && error.response?.data?.exceptions && error.response.data.exceptions.length > 0) {
                return rejectWithValue(error.response.data.exceptions[0].Message);
            }
            
            if (error.response?.data?.exceptions && error.response.data.exceptions.length > 0) {
                // API yanıtındaki ilk exception'ın Message alanını döndür
                return rejectWithValue(error.response.data.exceptions[0].Message);
            } else if (error.response?.data?.message) {
                // Alternatif message alanı
                return rejectWithValue(error.response.data.message);
            } else if (error.response?.data) {
                // Genel hata yanıtı
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message || 'İşlem sırasında bir hata oluştu');
        }
    }
);

export const getApproved = createAsyncThunk(
    'supplier/getApproved',
    async ({ dtStart, dtEnd }, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/SupAccount/get-approved`,
                { dtStart, dtEnd }
            );

            if (response.data?.statu === 200) {
                return response.data.data || [];
            }

            return rejectWithValue(response.data?.exceptions?.[0] || 'Onaylı kayıtlar alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Onaylı kayıtlar yüklenirken bir hata oluştu');
        }
    }
);

export const getWithoutPictureServices = createAsyncThunk(
    'supplier/getWithoutPictureServices',
    async ({ dtStart, dtEnd }, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/SupAccount/without-picture-services`,
                { dtStart, dtEnd }
            );
            
            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Kayıtlar alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Kayıtlar yüklenirken bir hata oluştu');
        }
    }
);

// Async thunk for invoice against upload (idSupplier === 1740 için özel)
export const uploadInvoiceAgainst = createAsyncThunk(
    'supplier/uploadInvoiceAgainst',
    async (data, { rejectWithValue }) => {
        try {
            // Token'ı data'dan çıkar ve header'a ekle
            const { token, ...invoiceData } = data;
            const headers = {};
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/invoice-against`,
                invoiceData,
                { headers }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Fatura yüklenirken hata oluştu');
        }
    }
);

const supplierSlice = createSlice({
    name: 'supplier',
    initialState,
    reducers: {
        clearSupplierDetail: (state) => {
            state.supplierDetail = {
                loading: false,
                error: null,
                info: null,
                data: null
            };
        },
        clearApproveStatus: (state) => {
            state.approve = {
                loading: false,
                error: null,
                success: false
            };
        },
        clearKmAction: (state) => {
            state.kmAction = {
                loading: false,
                error: null,
                success: false
            };
        },
        clearApprovalList: (state) => {
            state.approvalList = { data: [], loading: false, error: null };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSuppliers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSuppliers.fulfilled, (state, action) => {
                state.loading = false;
                state.suppliers = action.payload;
                state.error = null;
            })
            .addCase(fetchSuppliers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchSuppliersCheckmate.pending, (state) => {
                state.checkmateSuppliersLoading = true;
                state.checkmateSuppliersError = null;
            })
            .addCase(fetchSuppliersCheckmate.fulfilled, (state, action) => {
                state.checkmateSuppliersLoading = false;
                state.checkmateSuppliers = action.payload;
                state.checkmateSuppliersError = null;
            })
            .addCase(fetchSuppliersCheckmate.rejected, (state, action) => {
                state.checkmateSuppliersLoading = false;
                state.checkmateSuppliersError = action.payload;
            })
            .addCase(addSupplier.pending, (state) => {
                state.actionLoading = true;
                state.error = null;
            })
            .addCase(addSupplier.fulfilled, (state) => {
                state.actionLoading = false;
                state.error = null;
            })
            .addCase(addSupplier.rejected, (state, action) => {
                state.actionLoading = false;
                state.error = action.payload;
            })
            .addCase(updateSupplier.pending, (state) => {
                state.actionLoading = true;
                state.error = null;
            })
            .addCase(updateSupplier.fulfilled, (state) => {
                state.actionLoading = false;
                state.error = null;
            })
            .addCase(updateSupplier.rejected, (state, action) => {
                state.actionLoading = false;
                state.error = action.payload;
            })
            .addCase(getSupplierInfo.pending, (state) => {
                state.supplierInfoLoading = true;
                state.supplierInfoError = null;
            })
            .addCase(getSupplierInfo.fulfilled, (state, action) => {
                state.supplierInfoLoading = false;
                state.supplierInfo = action.payload;
                state.supplierInfoError = null;
            })
            .addCase(getSupplierInfo.rejected, (state, action) => {
                state.supplierInfoLoading = false;
                state.supplierInfoError = action.payload;
            })
            .addCase(getSupplier.pending, (state) => {
                state.supplierDetail.loading = true;
                state.supplierDetail.error = null;
            })
            .addCase(getSupplier.fulfilled, (state, action) => {
                state.supplierDetail.loading = false;
                state.supplierDetail.data = action.payload;
                state.supplierDetail.error = null;
            })
            .addCase(getSupplier.rejected, (state, action) => {
                state.supplierDetail.loading = false;
                state.supplierDetail.error = action.payload;
            })
            .addCase(fetchSupplierServices.pending, (state) => {
                state.supplierServices.loading = true;
                state.supplierServices.error = null;
            })
            .addCase(fetchSupplierServices.fulfilled, (state, action) => {
                state.supplierServices.loading = false;
                state.supplierServices.data = action.payload;
                state.supplierServices.error = null;
            })
            .addCase(fetchSupplierServices.rejected, (state, action) => {
                state.supplierServices.loading = false;
                state.supplierServices.error = action.payload;
            }) 
            .addCase(fetchSuppliersList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSuppliersList.fulfilled, (state, action) => {
                state.loading = false;
                state.suppliersList = action.payload;
                state.error = null;
            })
            .addCase(fetchSuppliersList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getSupplierBalance.pending, (state) => {
                state.balance.loading = true;
                state.balance.error = null;
            })
            .addCase(getSupplierBalance.fulfilled, (state, action) => {
                state.balance.loading = false;
                state.balance.data = action.payload;
                state.balance.error = null;
            })
            .addCase(getSupplierBalance.rejected, (state, action) => {
                state.balance.loading = false;
                state.balance.error = action.payload;
            })
            .addCase(getInitialSupplierInfo.pending, (state) => {
                state.supplierDetail.loading = true;
                state.supplierDetail.error = null;
            })
            .addCase(getInitialSupplierInfo.fulfilled, (state, action) => {
                state.supplierDetail.loading = false;
                state.supplierDetail.info = action.payload;
                state.supplierDetail.error = null;
            })
            .addCase(getInitialSupplierInfo.rejected, (state, action) => {
                state.supplierDetail.loading = false;
                state.supplierDetail.error = action.payload;
            })
            .addCase(getSupplierDetail.pending, (state) => {
                state.supplierDetail.loading = true;
                state.supplierDetail.error = null;
            })
            .addCase(getSupplierDetail.fulfilled, (state, action) => {
                state.supplierDetail.loading = false;
                state.supplierDetail.data = action.payload;
                state.supplierDetail.error = null;
            })
            .addCase(getSupplierDetail.rejected, (state, action) => {
                state.supplierDetail.loading = false;
                state.supplierDetail.error = action.payload;
            })
            .addCase(getApprovalList.pending, (state) => {
                state.approvalList.loading = true;
                state.approvalList.error = null;
            })
            .addCase(getApprovalList.fulfilled, (state, action) => {
                state.approvalList.loading = false;
                state.approvalList.data = action.payload;
                state.approvalList.error = null;
            })
            .addCase(getApprovalList.rejected, (state, action) => {
                state.approvalList.loading = false;
                state.approvalList.error = action.payload;
            })
            .addCase(setApprove.pending, (state) => {
                state.approve.loading = true;
                state.approve.error = null;
                state.approve.success = false;
            })
            .addCase(setApprove.fulfilled, (state) => {
                state.approve.loading = false;
                state.approve.error = null;
                state.approve.success = true;
            })
            .addCase(setApprove.rejected, (state, action) => {
                state.approve.loading = false;
                state.approve.error = action.payload;
                state.approve.success = false;
            })
            .addCase(getKmList.pending, (state) => {
                state.kmList.loading = true;
                state.kmList.error = null;
            })
            .addCase(getKmList.fulfilled, (state, action) => {
                state.kmList.loading = false;
                state.kmList.data = action.payload;
                state.kmList.error = null;
            })
            .addCase(getKmList.rejected, (state, action) => {
                state.kmList.loading = false;
                state.kmList.error = action.payload;
            })
            .addCase(addKm.pending, (state) => {
                state.kmAction.loading = true;
                state.kmAction.error = null;
                state.kmAction.success = false;
            })
            .addCase(addKm.fulfilled, (state) => {
                state.kmAction.loading = false;
                state.kmAction.error = null;
                state.kmAction.success = true;
            })
            .addCase(addKm.rejected, (state, action) => {
                state.kmAction.loading = false;
                state.kmAction.error = action.payload;
                state.kmAction.success = false;
            })
            .addCase(updateKm.pending, (state) => {
                state.kmAction.loading = true;
                state.kmAction.error = null;
                state.kmAction.success = false;
            })
            .addCase(updateKm.fulfilled, (state) => {
                state.kmAction.loading = false;
                state.kmAction.error = null;
                state.kmAction.success = true;
            })
            .addCase(updateKm.rejected, (state, action) => {
                state.kmAction.loading = false;
                state.kmAction.error = action.payload;
                state.kmAction.success = false;
            })
            // Ödeme talebi
            .addCase(setWithdrawPayment.pending, (state) => {
                state.withdrawPayment.loading = true;
                state.withdrawPayment.error = null;
            })
            .addCase(setWithdrawPayment.fulfilled, (state, action) => {
                state.withdrawPayment.loading = false;
                state.withdrawPayment.data = action.payload;
                state.withdrawPayment.error = null;
            })
            .addCase(setWithdrawPayment.rejected, (state, action) => {
                state.withdrawPayment.loading = false;
                state.withdrawPayment.error = action.payload;
            })
            .addCase(getWithoutPictureServices.pending, (state) => {
                state.withoutPictureServices.loading = true;
                state.withoutPictureServices.error = null;
            })
            .addCase(getWithoutPictureServices.fulfilled, (state, action) => {
                state.withoutPictureServices.loading = false;
                state.withoutPictureServices.data = action.payload;
                state.withoutPictureServices.error = null;
            })
            .addCase(getWithoutPictureServices.rejected, (state, action) => {
                state.withoutPictureServices.loading = false;
                state.withoutPictureServices.error = action.payload;
            })
            // Onaylanmış kayıtlar için
            .addCase(getApproved.pending, (state) => {
                state.approvalList.loading = true;
                state.approvalList.error = null;
            })
            .addCase(getApproved.fulfilled, (state, action) => {
                state.approvalList.loading = false;
                state.approvalList.data = action.payload;
                state.approvalList.error = null;
            })
            .addCase(getApproved.rejected, (state, action) => {
                state.approvalList.loading = false;
                state.approvalList.error = action.payload;
            })
            // Fatura yükleme işlemi için
            .addCase(uploadInvoiceAgainst.pending, (state) => {
                state.supplierDetail.loading = true;
                state.supplierDetail.error = null;
            })
            .addCase(uploadInvoiceAgainst.fulfilled, (state, action) => {
                state.supplierDetail.loading = false;
                state.supplierDetail.data = action.payload;
                state.supplierDetail.error = null;
            })
            .addCase(uploadInvoiceAgainst.rejected, (state, action) => {
                state.supplierDetail.loading = false;
                state.supplierDetail.error = action.payload;
            });
    }
});

export const { clearSupplierDetail, clearApproveStatus, clearKmAction, clearApprovalList } = supplierSlice.actions;
export default supplierSlice.reducer;
